"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var semantic_ui_react_1 = require("semantic-ui-react");
var classnames_1 = __importDefault(require("classnames"));
var FontIcon = function (props) {
    var name = props.name, semanticName = props.semanticName, className = props.className;
    if (semanticName) {
        return react_1.default.createElement(semantic_ui_react_1.Icon, { className: className, name: semanticName });
    }
    return react_1.default.createElement("i", { className: classnames_1.default('cm-icon', name, className) });
};
exports.default = FontIcon;
